<ng-container class="spinner-container">
	<mat-card class="panel-background" style="margin:20px;border-right-color:#484a5b;">
		<mat-card-header>
			<div fxFill fxLayout="row" fxLayoutAlign="space-between">
				<div data-idtest="guests-t-9Cw" class="card-title" translate>会員管理</div>
				<mat-paginator #paginator (page)="onPage($event)" [length]="count" [pageSize]="size" style="background-color: rgba(255,255,255,0);"></mat-paginator>
				<button *ngIf="authIs('studio')" data-idtest="guests-b-7Ej" welcome-dialog color="primary" [auth]="auth" [user]="user" matTooltip="{{'会員追加' | translate}}" [disabled]="isProgress" (success)="onRedraw()" (error)="onError($event)" mat-raised-button style="font-size:14px;font-weight:900;"><span data-idtest="guests-t-8Xv" translate>会員追加</span></button>
			</div>
		</mat-card-header>
		<mat-card-content>
			<div style="margin: 24px;" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-between">
				<mat-form-field *ngIf="authIs('studio')" fxFlex="30" fxFlex.lt-sm="100" style="width:100%;">
					<mat-label><span data-idtest="guests-t-3Ii" translate>メールアドレスで検索</span></mat-label>
					<input data-idtest="guests-i-1Dc" (change)="onFind();" [(ngModel)]="query_username" autocomplete="off" matInput placeholder="{{'メールアドレス'| translate}}" type="text">
					<button (click)="query_username='';onFind();" aria-label="Clear" mat-button mat-icon-button matSuffix id="mat-username-button">
						<mat-icon>close</mat-icon>
					</button>
				</mat-form-field>
				<mat-form-field *ngIf="authIs('studio')" fxFlex="30" fxFlex.lt-sm="100" style="width:100%;">
					<mat-label><span data-idtest="guests-t-2Tk" translate>お名前で検索</span></mat-label>
					<input data-idtest="guests-i-2Yb" (change)="onFind();" [(ngModel)]="query_nickname" autocomplete="off" matInput placeholder="{{'お名前' | translate}}" type="text">
					<button (click)="query_nickname='';onFind();" aria-label="Clear" mat-button mat-icon-button matSuffix id="mat-nickname-button">
						<mat-icon>close</mat-icon>
					</button>
				</mat-form-field>
				<mat-form-field *ngIf="authIs('studio')" class="input-text">
					<mat-label><span data-idtest="guests-t-2Qz" translate>会員種別で絞り込み</span></mat-label>
					<mat-select data-idtest="guests-m-4Xt" #type_select="ngModel" (selectionChange)="onFind()" [(ngModel)]="query_type" name="type_select">
						<mat-option *ngFor="let type of types" [value]="type.value">
							{{type.name}}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<!--	<div *ngIf="authIs('manager')">
						<a mat-raised-button color="warn" download="report.csv" href="/guests/auth/report/{{report_query}}/{{report_option}}">
							<span style="display: block;" translate>会員一覧CSV出力</span>
						</a>
					</div> -->
			</div>

			<mat-grid-list *ngIf="authIs('studio')" (window:resize)="onResize($event)" [cols]="breakpoint" rowHeight="1:1">
				<mat-grid-tile *ngFor="let account of results" [colspan]="account.cols" [rowspan]="account.rows" [ngStyle]="panelStyle(account)">
					<mat-grid-tile-header fxLayout="row" fxLayoutAlign="space-between center" style="padding-left:4px;padding-right:4px;line-height:32px; background-color: #8E6C41;">
						<!-- <app-image [fileName]="'avatar.jpg'" [view]="'visible'" [width]="32" [height]="32" [username]="account.username"></app-image> -->
						<button data-idtest="guests-b-5Ql" fxFlex="20" mat-icon-button guest-dialog matTooltip="{{'会員情報編集'| translate}}" style="color:#fdfdfd;" [auth]="auth" [account]="account" (success)="onRedraw()" (error)="onError($event)">
							<mat-icon>folder_shared</mat-icon>
						</button>

						<button data-idtest="guests-b-7Dv" *ngIf="authIs('manager')" fxFlex mat-icon-button belongs-dialog matTooltip="{{'紐付け編集'| translate}}" style="color:#fdfdfd;" [auth]="auth" [account]="account" [disabled]="isProgress" (success)="onRedraw()" (error)="onError($event)">
							<mat-icon>supervisor_account</mat-icon>
						</button>

						<button data-idtest="guests-b-4Sr" fxFlex mat-icon-button guest-username-dialog matTooltip="{{'メールアドレス変更'| translate}}" style="color:#fdfdfd;" [account]="account" [disabled]="isProgress" (success)="onRedraw()" (error)="onError($event)">
							<mat-icon>email</mat-icon>
						</button>

						<button data-idtest="guests-b-6Kl" fxFlex mat-icon-button guest-password-dialog matTooltip="{{'パスワード変更'| translate}}" style="color:#fdfdfd;" [account]="account" [disabled]="isProgress" (success)="onRedraw()" (error)="onError($event)">
							<mat-icon>lock</mat-icon>
						</button>

						<button data-idtest="guests-b-9Tq" fxFlex mat-icon-button delete-dialog matTooltip="{{'会員データ削除'| translate}}" style="color:#fdfdfd;" *ngIf="isSubscribe(account) !== 1" [account]="account" [disabled]="isProgress" (success)="onRedraw()" (error)="onError($event)">
							<mat-icon>clear</mat-icon>
						</button>

					</mat-grid-tile-header>
					<div fxLayout="column" fxlayoutalign="end" style="margin-top:6px;padding:8px;overflow: hidden;">
						<div style="font-weight:900; margin:10px auto;"><span translate>会員名</span>：{{account.nickname | truncate:10}}</div>
						<div style="font-weight:900; margin:10px auto;" [style.color]="account.auth | aig_authcolor"><span translate>会員種別</span>：{{typeToName(account.type) | translate}}</div>
						<div style="font-weight:500; margin:10px auto; font-size:12px;"><span translate>メール</span>：{{account.username | truncate:20}}</div>
						<!-- <div class="mat-caption" style="font-weight:500; margin:4px auto; overflow:hidden;">{{account.description | truncate:20}}</div> -->

						<div *ngIf="!isFixed(account) && authIs('manager') && !accountAuthLE(account,'studio')" style="font-weight:500;margin:10px auto;font-size:12px;color:#ef6e6e;">
							<button mat-raised-button color="primary" (click)="onFix(account)" >
								<span translate>fix</span>
							</button>

						<!--	<div *ngIf="test('aaaaa') | async as result">
								{{ result }}
							</div> -->

						</div>
						<div [ngSwitch]="isSubscribe(account)">
							<div *ngSwitchCase="1" style="font-weight:500;margin:10px auto;font-size:12px;color:#ef6e6e;">
								<button fxFlex mat-raised-button unsubscribe-dialog matTooltip="{{'退会処理'| translate}}" color="warn" [account]="account" [disabled]="isProgress" (success)="onRedraw()" (error)="onError($event)">
									退会
								</button>
							</div>
							<div *ngSwitchCase="0" style="font-weight:500;margin:10px auto;font-size:12px;color:#ffffff;">
								<span translate>未入会</span>
							</div>
							<div *ngSwitchCase="-1" style="font-weight:500;margin:10px auto;font-size:12px;color:#fff;">
								<span translate>未入会.</span>
							</div>
							<div *ngSwitchCase="-2" style="font-weight:500;margin:10px auto;font-size:12px;color:#fff;">
							</div>
							<div *ngSwitchDefault>{{isSubscribe(account)}}</div>
						</div>
						<div *ngIf="isAccounting(account)" style="font-weight:500;margin:10px auto;font-size:12px;color:#eeb161;">
							<span translate>請求書支払い</span>
						</div>
					</div>
				</mat-grid-tile>
			</mat-grid-list>
		</mat-card-content>
	</mat-card>
	<mat-spinner *ngIf="isProgress" class="spinner"></mat-spinner>
</ng-container>
